import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import MoneycessityLogo from "../../assets/header/MoneycessityLogo.png";
import MoneycessityMobileLogo from "../../assets/header/MoneycessityMobileLogo.png";

const LogoButton = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Link to="/">
      <button className="flex-grow text-center ml-14 md:ml-0 md:text-left md:flex-grow-0">
        <img
          src={isMobile ? MoneycessityMobileLogo : MoneycessityLogo}
          className="max-h-24 md:w-auto md:h-3/4"
          alt="Responsive Logo"
        />
      </button>
    </Link>
  );
};

export default LogoButton;
